import { Component,Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-faqs',
  //standalone: true,
  //imports: [],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss'
})
export class FaqsComponent {
  @Input() faqList = []
  @Input() application = ""
  @Input() module = ""
  @Input() page = ""


  constructor(
    private sanitizer: DomSanitizer,
  ) {
    console.log("fffff", this.faqList)
  }


  ngOnInit() {
    // `data` should be available here
    console.log('ngOnInit: data =', this.faqList);
  }



  displayDescription(desc: any) {
    let description = this.sanitizer.bypassSecurityTrustHtml(
      this.decodeHtml(desc)
    );
    console.log("=========safe desc======", description);
    console.log("lol", Object(description).changingThisBreaksApplicationSecurity)
    return description = Object(description).changingThisBreaksApplicationSecurity;

  }

  decodeHtml(html: string): string {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  }

}
